<script lang="ts">
    import { getContext, onDestroy } from 'svelte'
    import { derived as sderived } from 'svelte/store'
    import { fade } from 'svelte/transition'

    import { gettext as _ } from 'hydria/services/gettext'
    import type { IContact } from 'wdom/services/contacts'

    import PostalCode from 'wdom/components/contacts/PostalCode.svelte'
    import InternationalPhone from 'wdom/components/contacts/InternationalPhone.svelte'
    import Country from 'wdom/components/contacts/Country.svelte'
    import Province from 'wdom/components/contacts/Province.svelte'

    import type { DomainHandler } from './domain'
    import type { IDomain } from 'wdom/domain/interfaces'
    import { sanchor, spath } from 'hydria/svelte_helpers'

    const Domain = <DomainHandler>getContext('Domain')

    const status = sderived(Domain.status, ($status) => $status)

    let domain: IDomain = $derived($status == 'ready' ? Domain.domain : <IDomain>{})

    const contactTaskRunning = sderived(Domain.runningTasks.contact, ($running) => $running)

    function contactType(contact: IContact) {
        switch (contact.type) {
            case 'registrant':
                return $_('Registrant')
            case 'owner':
                return $_('Owner')
            case 'admin':
                return $_('Administrative')
            case 'billing':
                return $_('Billing')
            case 'tech':
                return $_('Technical')
        }
        return '–'
    }

    let confirmWebnamesPush = $state(false)
    $effect(() => {
        if (confirmWebnamesPush && !document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.add('modal-open')
        } else if (!confirmWebnamesPush && document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.remove('modal-open')
        }
    })
    onDestroy(() => {
        if (confirmWebnamesPush) document.documentElement.classList.remove('modal-open')
    })

    function pushToWebNames() {
        Domain.forcePushContacts()
        confirmWebnamesPush = false
    }
</script>

{#if $status == 'ready'}
    <div class="card card-contacts">
        <div class="card-title text-primary">{$_('Contacts')}</div>
        <div class="card-body">
            <div class="contact-container">
                {#each Domain.contacts as cdata}
                    <div>
                        <div>
                            <div class="type">
                                {contactType(cdata)}
                                {#if cdata.cira && cdata.cira.id}
                                    <div class="cira-id">{cdata.cira.id}</div>
                                {/if}
                            </div>
                            <div class="infos-contact">
                                <div class="name"><span>{cdata.name}</span></div>
                                {#if cdata.org}<div>{cdata.org}</div>{/if}
                                <br />
                                {#if cdata.email}<em>{cdata.email}</em>{/if}
                                {#each cdata.street as street}
                                    <div>{street}</div>
                                {/each}
                                {#if cdata.city || cdata.sp || cdata.postal_code}
                                    <div>
                                        {#if cdata.city}<span class="contact-right-space">{cdata.city}</span>{/if}
                                        {#if cdata.sp}<span><Province contact={cdata} /> ({cdata.sp})</span>{/if}
                                        <PostalCode contact={cdata} />
                                    </div>
                                {/if}
                                {#if cdata.country && cdata.country != 'CA'}
                                    <div><Country contact={cdata} /></div>
                                {/if}
                                {#if cdata.voice || cdata.fax}
                                    <br />
                                    {#if cdata.voice}<div><InternationalPhone phone={cdata.voice} /></div>{/if}
                                    {#if cdata.fax}<div><InternationalPhone phone={cdata.fax} /> <span class="text-muted">({$_('fax')})</span></div>{/if}
                                {/if}
                            </div>
                        </div>
                    </div>
                {/each}
            </div>

            {#if domain.status == 'ready'}
                {#if $contactTaskRunning}
                    <span class="text-warning"
                        ><div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                        &nbsp;&nbsp;{$_('The contacts are currently being changed. Please wait a moment.')}</span
                    >
                {:else if domain.system == 'webnames' && !Domain.webnamesCapabilities['contacts']}
                    <p>Ces contacts WebNames ne sont pas supportés.</p>
                    {@html $_('To manage the contacts for this domain, please contact us by phone at <a href="tel:8778809224">877 880-9224</a> or by email at <a href="mailto:tech@webdomaine.ca">tech@webdomaine.ca</a>.')}
                {:else}
                    {#if domain.system == 'webnames'}
                        <button type="button" class="btn btn-outline-secondary mt-3" onclick={() => (confirmWebnamesPush = true)}>Pousser les contacts actuels vers WebNames</button>
                    {/if}
                    <a use:sanchor href={spath(`/domain/${domain.idna}/contacts`)} class="btn btn-primary mt-3">{$_('Edit')}</a>
                {/if}
            {/if}
        </div>
    </div>
{/if}

{#if confirmWebnamesPush}
    <div class="modal" role="dialog" transition:fade={{ duration: 250 }}>
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header text-bg-primary">
                    <div>Pousser les contacts vers WebNames</div>
                </div>
                <div class="modal-body">
                    <p>Peut causer l’envoi d’email au client si le Owner change</p>
                </div>
                <div class="modal-footer text-bg-light">
                    <button type="button" class="btn btn-outline-secondary" onclick={() => (confirmWebnamesPush = false)}>{$_('Cancel')}</button>
                    <button type="button" class="btn btn-danger" onclick={() => pushToWebNames()}>Procéder à la mise à jour chez WebNames</button>
                </div>
            </div>
        </div>
        <div class="modal-backdrop" onclick={() => (confirmWebnamesPush = false)} aria-hidden="true"></div>
    </div>
{/if}
